import React, { useCallback, useState } from "react";
import AiFeatureToolPrep from "../../shared/Popup/AiFeatureToolPrep";
import AiMaskPaintPreview from "../../shared/Popup/AiMaskPaintPreview";
import AiMaskSelectToolControls, {
  isMaskSelectGenerateReady,
} from "../../shared/Popup/AiMaskSelectToolControls";
import { useAiMaskPaint } from "../../shared/Popup/useAiMaskPaint";

/**
 * AI Tools → AI Replace Text prep (Smart / Brush / Box / Eraser + new text).
 */
const ReplaceTextToolPrep = (props) => {
  const [prompt, setPrompt] = useState("");
  const paint = useAiMaskPaint();
  const toolId = paint.paintTool;

  const isGenerateReady = useCallback(
    () =>
      isMaskSelectGenerateReady(toolId, paint.hasMask, {
        prompt,
        promptRequired: true,
      }),
    [toolId, paint.hasMask, prompt]
  );

  return (
    <AiFeatureToolPrep
      {...props}
      toolKey="ai_replace_text"
      title="AI Replace Text"
      aka="Text Replacer"
      bio="Change text in the image and rebuild the background."
      emptyPreviewLabel="Upload an image to preview text replace"
      loadingLabel="Replacing text…"
      emptyFooterHint="Pick a tool, enter the new wording, then generate."
      isGenerateReady={isGenerateReady}
      renderPreview={({
        imageUrl,
        loading,
        loadingLabel,
        emptyLabel,
        hasResult,
      }) => (
        <AiMaskPaintPreview
          ref={paint.maskRef}
          imageUrl={imageUrl}
          loading={loading}
          loadingLabel={loadingLabel}
          emptyLabel={emptyLabel}
          tool={toolId}
          brushSize={paint.brushSize}
          paintEnabled={
            !hasResult &&
            Boolean(imageUrl) &&
            !loading &&
            toolId !== "smart"
          }
          clearVersion={paint.clearVersion}
          onMaskChange={paint.handleMaskChange}
        />
      )}
      renderControls={({ busy, leftPanelRef, sourceImageUrl }) => (
        <>
          <AiMaskSelectToolControls
            paint={paint}
            busy={busy}
            sourceImageUrl={sourceImageUrl}
            leftPanelRef={leftPanelRef}
            subject="text"
          />
          <div className="aftp-section">
            <label className="aftp-label" htmlFor="aftp-rpt-prompt">
              New text
            </label>
            <textarea
              id="aftp-rpt-prompt"
              className="aftp-input"
              rows={3}
              value={prompt}
              onChange={(e) => {
                setPrompt(e.target.value);
              }}
              placeholder="e.g. SUMMER SALE, Open Daily 9–5"
              disabled={busy}
            />
          </div>
        </>
      )}
    />
  );
};

export default ReplaceTextToolPrep;
